<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />
      <action-button type="save" @click="save" />
    </v-app-bar>

    <v-card>
      <v-card-text class="pa-4">
        <v-form ref="form">
          <v-flex md12>
            <span v-for="all_role in all_roles" :key="all_role.id" class="mr-3">
              <input v-model="checked" type="checkbox" name="chk_role" :value="all_role.name" :checked="checked.includes(all_role.name)" />
              {{ all_role.name }}
            </span>
          </v-flex>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "UserRoles",

  props: ["id"],

  data() {
    return {
      page_title: "",
      user: {},
      person: {},
      roles: [],
      all_roles: [],
      checked: []
    }
  },

  created() {
    let vm = this

    if (!this.id) {
      this.user = {}
    } else {
      // Get user
      axios
        .get(this.API_URL + "user/" + this.id)
        .then((res) => {
          this.user = res.data.data
          this.person = res.data.data.person
          this.roles = res.data.data.roles

          this.page_title = this.$t("users.edit_role", { name: this.person.first_name + " " + this.person.last_name })

          this.roles.forEach(function (value) {
            vm.checked.push(value.name)
          })

          // Get user roles
          axios
            .get(this.API_URL + "roles")
            .then((res) => {
              this.all_roles = res.data.data
            })
            .catch((err) => console.log(err))
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      let vm = this

      axios
        .post(this.API_URL + "user/roles", {
          id: vm.id,
          roles: vm.checked
        })
        .then((res) => {
          let data = res.data.data

          if (data.id) {
            vm.$store.dispatch("auth/updateUserState", vm)
            vm.$awn.success(vm.$t("global.create_success"))
          }
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped></style>
